import { ApiResponse } from "@/interfaces/api-response.interface";
import { api } from "@/lib/api/axios";
import {
  BankAccount,
  BankStatementSummary,
  BankStatementTransaction,
  ImportFileData,
  CreateTransactionData,
  UpdateTransactionData,
  BankStatementFilters,
} from "@/types/bank-statement";

export const bankStatementService = {
  // Bank accounts
  fetchBankAccounts: async () => {
    const response = await api.get<ApiResponse<BankAccount[]>>("/bank-statements/accounts");
    return response;
  },

  // Transactions
  fetchStatements: async (filters?: BankStatementFilters) => {
    const response = await api.get<ApiResponse<BankStatementTransaction[]>>("/bank-statements", { params: filters });
    return response;
  },

  fetchTransactionById: async (id: number) => {
    const response = await api.get<BankStatementTransaction>(`/bank-statements/${id}`);
    return response;
  },

  // Summary
  fetchSummary: async (accountId?: number, movieId?: number) => {
    const response = await api.get<ApiResponse<BankStatementSummary>>("/bank-statements/summary", {
      params: { accountId, movieId },
    });
    return response;
  },

  // Import file
  importFile: async (data: ImportFileData) => {
    const formData = new FormData();
    formData.append("file", data.file);
    if (data.movieId !== undefined && data.movieId !== null) {
      formData.append("movieId", data.movieId.toString());
    }
    if (data.accountId !== undefined && data.accountId !== null) {
      formData.append("accountId", data.accountId.toString());
    }

    const response = await api.post<{ imported: number; transactions: BankStatementTransaction[] }>(
      "/bank-statements/import",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response;
  },

  // CRUD operations
  createRelease: async (data: CreateTransactionData) => {
    const response = await api.post<BankStatementTransaction>("/bank-statements", data);
    return response;
  },

  updateRelease: async (id: number, data: UpdateTransactionData) => {
    const response = await api.patch<BankStatementTransaction>(`/bank-statements/${id}`, data);
    return response;
  },

  deleteRelease: async (id: number): Promise<void> => {
    await api.delete(`/bank-statements/${id}`);
  },

  // Export - returns blob directly, no wrapper
  exportTransactions: (filters?: BankStatementFilters, format: "xlsx" | "pdf" = "xlsx") =>
    api.get<Blob>("/bank-statements/export", {
      params: { ...filters, format },
      responseType: "blob",
    }),
};
